import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axiosInstance from './axiosConfig';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [userId, setUserId] = useState(null); // Agregar estado para el userId

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Verifica la autenticación y obtiene el userId
        const response = await axiosInstance.get(`/api/check-auth`);
        if (response.status === 200) {
          setIsAuthenticated(true);
          setUserId(response.data.userId); // Almacena el userId
          localStorage.setItem('userId', response.data.userId); // Opcional: Guardarlo en localStorage para acceder desde otros componentes
        }
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return <div>Cargando...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return children; // Renderiza los children solo si está autenticado
};

export default ProtectedRoute;
